









export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    shape: {
      type: [Array, Object],
    },
  },
  methods: {
    add() {
      // create new, unbound instance of shape
      const shape = Array.isArray(this.shape)
        ? [this.shape.slice(0)]
        : { ...this.shape };

      const payload = this.value.concat(shape);
      this.$emit('input', payload);
    },
  },
} as IView;
